<template>
  <dl class="flag" :class="{ warning: record.warning, clickable: clickCallback }">
    <dd>
      <div class="label">
        <span>{{ record.areaName ?? '未知地区' }}</span>
      </div>
      <div class="value">
        <span>{{ record.progress ?? '--' }}%</span>
      </div>
    </dd>
  </dl>
</template>

<script>
export default {
  props: {
    // { lnglat1:{}, lnglat2:{}, }
    data: {
      type: Object,
      default: () => ({}),
    },
    clickCallback: {
      type: Function,
      default: null,
    },
  },
  data() {
    let self = this;
    return {
      record: self.data || {},
    };
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
dl.flag {
  pointer-events: none;
  position: relative;
  z-index: 1;
  user-select: none;
  width: 0;
  height: 0;
  --color: #1c7700;
  &.warning {
    --color: #784a00;
    dd {
      background-image: url(./icons/icon_map_flag_warning.png);
    }
  }
  &.clickable {
    dd {
      div {
        span {
          pointer-events: all;
          cursor: pointer;
        }
      }
    }
  }
  dd {
    width: vw(83);
    height: vh(56);
    box-sizing: content-box;
    background-image: url(./icons/icon_map_flag_default.png);
    background-size: 100%;
    position: absolute;
    left: 50%;
    bottom: vh(-6);
    transform: translate(-50%, 0);
    white-space: nowrap;
    text-align: center;
    padding: vh(5) vw(10);
    div {
      color: #fff;
      font-weight: bold;
      font-style: italic;
      line-height: 1.2;
      text-shadow: vw(2) vw(0) vw(1) var(--color), vw(2) vw(2) vw(1) var(--color), vw(0) vw(2) vw(1) var(--color), vw(-2) vw(2) vw(1) var(--color), vw(-2) vw(0) vw(1) var(--color), vw(-2) vw(-2) vw(1) var(--color), vw(0) vw(-2) vw(1) var(--color), vw(2) vw(-2) vw(1) var(--color);
      &.label {
        font-size: fontSize(12);
      }
      &.value {
        font-size: fontSize(18);
      }
      span {
        cursor: default;
      }
    }
  }
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
</style>
